import { useState, useEffect } from 'react';

interface WindowSize {
  width?: number;
  height?: number;
}

export default function useWindowSize() {
  const getSize = () => {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  };

  const [windowSize, setWindowSize] = useState<WindowSize>({});

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(getSize());
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}
